export default function Process() {
  const timeline = [
    {
      step: 1,
      title: '無料10分診断',
      text: '現状ヒアリング＋サイト確認。原因と打ち手の方向性を提示。'
    },
    {
      step: 2,
      title: '改善設計（LP/導線/計測）',
      text: 'コピーと構成を決定。計測の不備があれば先に直します。'
    },
    {
      step: 3,
      title: '改修（あなた側/こちら側どちらでも可）',
      text: 'Shopify/WordPress/静的LPなど運用に合わせて対応。'
    },
    {
      step: 4,
      title: '少額広告で検証',
      text: '"問い合わせが起きる条件"を数値で確認。改善を反復。'
    }
  ];

  return (
    <section id="process" className="py-20 md:py-28 bg-white">
      <div className="max-w-[1000px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            進め方（最短）
          </h2>
        </div>

        <div className="space-y-8">
          {timeline.map((item, index) => (
            <div key={index} className="relative">
              <div className="flex items-start gap-6">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-full">
                    <span className="text-white text-2xl font-black">{item.step}</span>
                  </div>
                </div>
                <div className="flex-1 pt-2">
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">{item.title}</h3>
                  <p className="text-base md:text-lg text-gray-600 leading-relaxed">{item.text}</p>
                </div>
              </div>
              {index < timeline.length - 1 && (
                <div className="ml-8 mt-4 mb-4 h-12 w-0.5 bg-gray-200"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
